<template>
    <layout>
        <dashboard />
    </layout>
</template>

<script>
import Layout from '@/layouts/Layout.vue';
import Dashboard from '@/components/dashboard/Dashboard.vue';

export default {
    components: {
        Layout,
        Dashboard,
    },
};
</script>
